<template>
  <div class="resource-exchange coming-soon">
    <page-header title="资源交流信息" style="margin-bottom: 20px;" />
    <ming-table :fields="column" :data="data" />

  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader'
import { resourceExchange } from './tableColumn'
import { ref } from 'vue'

const column = ref(resourceExchange)
const data = ref([])

</script>
